(() => {
  const OWN_PARAMS = ["view", "pack", "quantity", "variant"];
  const incoming = new URLSearchParams(window.location.search);
  let data = null;
  try {
    data = JSON.parse(document.getElementById("NappiFunnelData")?.textContent || "null");
  } catch (error) {
    data = null;
  }
  const forwardParams = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return href;
      incoming.forEach((value, key) => {
        if (OWN_PARAMS.includes(key) || url.searchParams.has(key)) return;
        url.searchParams.set(key, value);
      });
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return href;
    }
  };
  const stepUrl = (view, params = {}) => {
    const base = data?.url || window.location.pathname;
    const url = new URL(base, window.location.origin);
    url.searchParams.set("view", view);
    Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));
    return forwardParams(url.pathname + url.search);
  };
  const tier = (n) => data?.tiers ? data.tiers[String(n)] || null : null;
  const freeShipping = (n) => {
    const t = tier(n);
    if (!t || !data) return false;
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    return t.saleCents >= Math.round(data.freeShippingShopCents * rate);
  };
  const offsetMs = (tz) => {
    const match = /^([+-])(\d{2})(\d{2})$/.exec(tz || "");
    return match ? (match[1] === "-" ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3])) * 6e4 : 0;
  };
  const shipLabel = (tz) => {
    const date = new Date(Date.now() + offsetMs(tz) + 864e5);
    const lang = document.documentElement.lang || "en";
    if (!/^en\b/i.test(lang)) {
      try {
        return date.toLocaleDateString(lang, { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" });
      } catch (error) {
      }
    }
    const day = date.getUTCDate();
    const teen = day % 100 >= 11 && day % 100 <= 13;
    const suffix = teen ? "th" : { 1: "st", 2: "nd", 3: "rd" }[day % 10] || "th";
    const weekday = date.toLocaleDateString("en-US", { weekday: "short", timeZone: "UTC" });
    const month = date.toLocaleDateString("en-US", { month: "short", timeZone: "UTC" });
    return `${weekday}, ${month} ${day}${suffix}`;
  };
  const formatMoney = (cents) => {
    const sample = data?.moneySample || "";
    const match = sample.match(/^(\D*?)(\d[\d.,\u00a0\u202f ]*\d|\d)(\D*)$/);
    const value = Math.round(Number(cents) || 0);
    if (!match) return (value / 100).toFixed(2);
    const [, before, number, after] = match;
    const hasDecimals = /[.,](\d{2})$/.test(number);
    const decimalSep = hasDecimals ? number[number.length - 3] : "";
    const whole = hasDecimals ? number.slice(0, -3) : number;
    const groupSep = (whole.match(/[^\d]/) || [""])[0];
    const units = String(Math.floor(value / 100));
    const grouped = groupSep ? units.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep) : units;
    const round = value % 100 === 0;
    const digits = round || !decimalSep ? grouped : `${grouped}${decimalSep}${String(value % 100).padStart(2, "0")}`;
    return `${before}${digits}${after}`;
  };
  const shippingFee = () => {
    const rate = Number(window.Shopify?.currency?.rate) || 1;
    return formatMoney(Math.round((data?.shippingFeeShopCents || 0) * rate));
  };
  window.NappiFunnel = { data, tier, freeShipping, stepUrl, forwardParams, shipLabel, formatMoney, shippingFee };
  if (data) {
    const TOKEN = "[shipping-fee]";
    document.querySelectorAll(".nappi-funnel").forEach((scope) => {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => node.nodeValue.includes(TOKEN) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
      });
      const found = [];
      while (walker.nextNode()) found.push(walker.currentNode);
      found.forEach((node) => {
        node.nodeValue = node.nodeValue.split(TOKEN).join(shippingFee());
      });
    });
  }
  document.querySelectorAll("[data-ship-date]").forEach((el) => {
    el.textContent = shipLabel(el.closest("[data-tz-offset]")?.dataset.tzOffset);
  });
  document.querySelectorAll("a[data-nappi-forward]").forEach((link) => {
    link.setAttribute("href", forwardParams(link.getAttribute("href")));
  });
  document.querySelectorAll("[data-nappi-countdown]").forEach((root) => {
    const hours = root.querySelectorAll("[data-nappi-countdown-h]");
    const minutes = root.querySelectorAll("[data-nappi-countdown-m]");
    const seconds = root.querySelectorAll("[data-nappi-countdown-s]");
    if (!hours.length) return;
    const shift = offsetMs(root.dataset.tzOffset);
    const cutoff = Math.min(Math.max(Number(root.dataset.cutoffHour) || 24, 1), 24);
    const pad = (n) => String(n).padStart(2, "0");
    const tick = () => {
      const now = Date.now();
      const shop = new Date(now + shift);
      let target = Date.UTC(shop.getUTCFullYear(), shop.getUTCMonth(), shop.getUTCDate(), cutoff) - shift;
      if (target <= now) target += 864e5;
      const left = Math.max(0, Math.floor((target - now) / 1e3));
      const h = pad(Math.floor(left / 3600));
      const m = pad(Math.floor(left % 3600 / 60));
      const s = pad(left % 60);
      hours.forEach((el) => {
        el.textContent = h;
      });
      minutes.forEach((el) => {
        el.textContent = m;
      });
      seconds.forEach((el) => {
        el.textContent = s;
      });
    };
    tick();
    window.setTimeout(() => {
      tick();
      window.setInterval(tick, 1e3);
    }, 1e3 - Date.now() % 1e3);
  });
})();
